export default {
  'SLModal.default.okText': 'เสร็จสมบูรณ์',
  'SLModal.default.cacelText': 'ยกเลิก',
  'SLModal.info.okText': 'ฉันเข้าใจแล้ว'
};